import { readableDeviceName } from '@iotv/core-services';
import { CalculateBatteryFromVoltages, getDurationHourMinSecStr, roundDecimals } from '@iotv/datamodel-core';
import { Networks } from '@iotv/iotv-v3-types';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);
export const NWName = (value, row, column, apiRef) => {
    const nwId = value;
    switch (nwId) {
        case Networks.ThingPark:
            return 'TP';
        case Networks.TTN_Community:
            return 'TTNC';
        case Networks.TTN_Enterprise:
            return 'TTNE';
        case Networks.Chirpstack:
            return 'CS';
        case Networks.Interceptor:
            return 'INT';
        case Networks.AWS_LPWAN:
            return 'AWS';
        case Networks.Helium:
            return 'HE';
        default:
            return nwId;
    }
};
export const DeviceTypeFormatter = (value, row, column, apiRef) => {
    return readableDeviceName(value);
};
export const sinceNow = (value, row, column, apiRef) => {
    let res = 'never';
    if (typeof value === 'number') {
        const duration = Date.now() - value;
        res = getDurationHourMinSecStr(duration);
    }
    return res;
};
export const voltageToPercentage = (value, row, column, apiRef) => {
    let res = '';
    if (typeof value === 'number') {
        res = roundDecimals(CalculateBatteryFromVoltages(value), 1) + '%';
    }
    return res;
};
export const dateTimeNow = (value, row, column, apiRef) => {
    let res = 'never';
    if (typeof value === 'number') {
        return new Date(value).toLocaleString();
    }
    return res;
};
export const NormalCase = (value, row, column, apiRef) => {
    if (typeof value === 'string') {
        return value.substring(0, 1).toLocaleUpperCase() + value.substring(1).toLocaleLowerCase().toLocaleLowerCase();
    }
    return '';
};
export const firstCharacter = (value, row, column, apiRef) => {
    let res = 'never';
    if (typeof value === 'string') {
        return value.substring(0, 1);
    }
    return res;
};
export const timeNow = (value, row, column, apiRef) => {
    let res = 'never';
    if (typeof value === 'number') {
        return new Date(value).toLocaleTimeString();
    }
    return res;
};
export const duration = (value, row, column, apiRef) => {
    let res = 'unknown';
    if (typeof value === 'number') {
        const duration = value;
        res = getDurationHourMinSecStr(duration);
    }
    return res;
};
export const convertFirmwareCode = (p) => {
    if (typeof p === 'string' && typeof parseInt(p) === 'number') {
        let hex = parseInt(p);
        if (isNaN(hex)) {
            return 'Unknown';
        }
        let hexed = parseInt(p).toString(16);
        if (hexed.length === 3) {
            hexed = '0' + hexed;
        }
        return hexed.substring(2) + '.' + hexed.substring(0, 2);
    }
    else {
        return `Unknown`;
    }
};
